module.exports = __webpack_public_path__ + "img/znpc-logo-hover.5da1a749.png";